"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistTargetsResponseToJSON = exports.ArtistTargetsResponseFromJSONTyped = exports.ArtistTargetsResponseFromJSON = exports.instanceOfArtistTargetsResponse = void 0;
var runtime_1 = require("../runtime");
var ContentPromotionBase_1 = require("./ContentPromotionBase");
/**
 * Check if a given object implements the ArtistTargetsResponse interface.
 */
function instanceOfArtistTargetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfArtistTargetsResponse = instanceOfArtistTargetsResponse;
function ArtistTargetsResponseFromJSON(json) {
    return ArtistTargetsResponseFromJSONTyped(json, false);
}
exports.ArtistTargetsResponseFromJSON = ArtistTargetsResponseFromJSON;
function ArtistTargetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'artists': !(0, runtime_1.exists)(json, 'artists') ? undefined : (json['artists'].map(ContentPromotionBase_1.ContentPromotionBaseFromJSON)),
    };
}
exports.ArtistTargetsResponseFromJSONTyped = ArtistTargetsResponseFromJSONTyped;
function ArtistTargetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'artists': value.artists === undefined ? undefined : (value.artists.map(ContentPromotionBase_1.ContentPromotionBaseToJSON)),
    };
}
exports.ArtistTargetsResponseToJSON = ArtistTargetsResponseToJSON;
